import React from 'react';
import { observer } from 'mobx-react-lite';

import { MaImagesSection } from './ma-imagespanel';
import { MaIconsSection } from './ma-iconpanel'
import { MaSizesSection } from './ma-sizespanel';
import { MaTemplatesSection } from './ma-customtemplates';

import {
  SidePanel,
  TextSection,
  ElementsSection,
  UploadSection,
  BackgroundSection,
} from 'polotno/side-panel';


// Definir as sections existentes e custom, aparecem pela ordem da array
const sections = [TextSection, MaImagesSection, MaIconsSection, ElementsSection, UploadSection, BackgroundSection, MaSizesSection];

export default observer(({ store }) => {
  return (
    <SidePanel store={store} sections={sections} defaultSection='photos' />
  )
});